import { actionCreatorFactory } from "typescript-fsa";

const actionFactory = actionCreatorFactory("MODULF_OPENREGISTER");

export const SUBMIT_SELECT_OPENREGISTER_RECORD = actionFactory<{
	activityId: string;
	recordId: string;
}>("SUBMIT_SELECT_OPENREGISTER_RECORD");
